// extracted by mini-css-extract-plugin
export var dropdown = "_sp-0";
export var imageWrapper = "_sp-3";
export var itemNameContainer = "_sp-1";
export var productImage = "_sp-2";
export var spinnerWrapper = "_sp-4";